export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-bottom">
          <p>
            © {new Date().getFullYear()} Inova — Todos os direitos reservados.
          </p>
          <nav aria-label="Links legais" className="footer-legal">
            <a href="/politica-privacidade" className="link">
              Política de Privacidade
            </a>
            <span aria-hidden> · </span>
            <a href="/politica-cookies" className="link">
              Política de Cookies
            </a>
            <span aria-hidden> · </span>
            <a href="/termos-uso" className="link">
              Termos de Uso
            </a>
            <span aria-hidden> · </span>
            <a href="/aceite-ciencia" className="link">
              Aceite e Ciência
            </a>
            <span aria-hidden> · </span>
            <ManageConsentLink />
          </nav>
        </div>
      </div>
    </footer>
  );
}

import { useConsent } from "./Consent.jsx";

function ManageConsentLink() {
  const { openManager } = useConsent();
  return (
    <button type="button" className="link btn-link" onClick={openManager}>
      Preferências de Cookies
    </button>
  );
}
